import { LandingScreen } from '@/components/LandingScreen';
import { useTheme } from '@/hooks/useTheme';

/**
 * The site is a single marketing landing page whose only call to action is
 * downloading the app.
 *
 * Everything else was removed once the mobile app went account-free: the web
 * app at /app/** (built entirely on Firebase Auth + Firestore sync) and the
 * /s/<shareId> public share viewer. Hosting still rewrites every path to
 * index.html, so old share URLs resolve to this page rather than erroring.
 */
export default function App() {
  const { colors } = useTheme();
  return <LandingScreen colors={colors} />;
}
